<!-- Copyright 2025, Common Good Learning Tools LLC -->
<template><div class="k-stumpy-div-outer-wrapper">
	<div v-if="show_top_hide_btn" class="k-stumpy-div-btn-wrapper">
		<k-btn x-small block text color="#555" style="border-radius:0" 
			@click="show_full=false;$emit('stumpy_toggle_show_full', show_full)"
		>
			Show Less
			<k-icon small class="ml-2">fas fa-caret-up</k-icon>
		</k-btn>
	</div>
	<div class="k-stumpy-div-inner-wrapper" :style="inner_div_style">
		<slot></slot>
	</div>
	<div v-if="show_btn" class="k-stumpy-div-btn-wrapper">
		<k-btn x-small block text color="#555" style="border-radius:0" 
			@click="show_full=!show_full;$emit('stumpy_toggle_show_full', show_full)"
		>
			Show {{show_full?'Less':'More'}}
			<k-icon small class="ml-2">fas fa-caret-{{show_full?'up':'down'}}</k-icon>
		</k-btn>
	</div>
</div></template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	props: {
		// req: { type: String, required: true },
		min_height: { type: Number, required: false, default() { return 100} },
		uuid: { required: false, default() { return ''} },
		no_transition: { required: false, default() { return false } },
		trigger: { required: false, default() { return ''} },
	},
	data() { return {
		counter: 1,
		show_btn: false,
		show_full: false,
		was_auto: false,
		full_height: 0,
	}},
	computed: {
		...mapState([]),
		...mapGetters([]),
		// this computes the style for the inner div, and as side effects may change show_btn and show_full
		inner_div_style() {
			if (this.counter < 1) return

			// el.scrollHeight returns the height the div *would* be if it was fully showing, even if it's partially hidden
			let $jq = $(this.$el).find('.k-stumpy-div-inner-wrapper')
			let full_height = ($jq.length) ? $jq[0].scrollHeight : 0
			let style
			// console.warn(`height: ${full_height} / ${this.was_auto}`)

			// if full_height is 0, nothing is showing yet; set to height:auto and try again later
			if (full_height == 0) {
				this.show_btn = false
				clearTimeout(this.waiter)
				this.waiter = setTimeout(x=>++this.counter, 100)
				this.was_auto = true
				style = `height:auto;`

			// if the full_height is shorter than min_height, always show, and don't show the btn
			} else if (full_height <= this.min_height) {
				this.show_btn = false
				this.show_full = true
				this.was_auto = false
				// note: we previously had this set to full_height, but that screws things up when we have expandable content inside the stumpydiv...
				// style = `height:${full_height}px;`
				style = `height:auto;`

			} else {
				// else we show the btn to determine whether or not to show_full, and base style on this.show_full
				this.show_btn = true
				if (this.show_full) {
					this.was_auto = false
					// note: we previously had this set to full_height, but that screws things up when we have expandable content inside the stumpydiv...
					// style = `height:${full_height}px;`
					style = `height:auto;`
				} else {
					if (this.was_auto) {
						// if we were auto-sized before, set to full_height, then immediately trigger again; that ensures that the animation works properly
						this.was_auto = false
						setTimeout(x=>++this.counter)
						style = `height:${full_height}px;`

					} else {
						style = `height:${this.min_height}px;`
					}
				}
			}

			this.full_height = full_height

			U.local_storage_set(`stumpy_div_${this.uuid}`, this.show_full)

			if (this.no_transition) {
				style += ' transition:none;'
			}
			return style
		},

		show_top_hide_btn() {
			if (!this.show_btn) return false
			if (!this.show_full) return false
			if (this.full_height < 300) return false
			return true
		},
	},
	watch: {
		'$vuetify.breakpoint.width'() {
			// update params when page width changes
			++this.counter
		},
		trigger() {
			// update params when optional trigger changes
			// console.warn('trigger changed')
			setTimeout(x=>++this.counter)
		},
	},
	created() {
		if (!empty(this.uuid)) {
			this.show_full = U.local_storage_get(`stumpy_div_${this.uuid}`) || false
			// console.warn(`loaded from ${this.uuid}: ${this.show_full}`)
		}
	},
	mounted() {
	},
	methods: {
	}
}
</script>

<style lang="scss">
.k-stumpy-div-outer-wrapper {

}

.k-stumpy-div-inner-wrapper {
	transition: height .2s;
	overflow:hidden;
	padding-bottom:4px;	// we always have a line at the bottom of the stumpy-div, so make sure we have some padding above the line
}

.k-stumpy-div-btn-wrapper {
	// border-top:1px solid #ccc;
	text-align:center;
	max-width:500px;
	margin:0 auto;
}
</style>